import * as React from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
const FullWidthContentColor = ({
  title = "",
  content,
  className,
  backgroundColor = "#eaeaea",
}) => {
  let count = 0;
  return (
    <>
      {title ? (
        <>
          <section className="section mb-0 pb-1" style={{ backgroundColor }}>
            <div className="content">
              <span className="full-width-title">{title}</span>
            </div>{" "}
          </section>
        </>
      ) : null}
      {content.map((item) => {
        count++;
        return (
          <React.Fragment key={nanoid()}>
            <section className={`section section--gradient orange-${count}`}>
              <div className={`white-box ${className}`}>
                <div className="m-4">{item}</div>
              </div>
            </section>
          </React.Fragment>
        );
      })}
    </>
  );
};

FullWidthContentColor.propTypes = {
  title: PropTypes.string,
  content: PropTypes.array,
  className: PropTypes.string,
};

export default FullWidthContentColor;
